/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'fill-tablet-check': {
    width: 128,
    height: 128,
    viewBox: '-192 -192 896 896',
    data: '<!--!Font Awesome Pro 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--><g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd"><g transform="translate(8 6)" _fill="#FFF" fill-rule="nonzero"><path pid="0" d="M0 64C0 28.7 28.7 0 64 0h320c35.3 0 64 28.7 64 64v134.6c-23.8 6.7-45.5 18.3-64 33.6V64H64v320h256.7c4.7 52.4 32.5 98.2 73 127.3-3.2.5-6.4.7-9.8.7H64c-35.3 0-64-28.7-64-64V64zm192 384c0 17.7 14.3 32 32 32s32-14.3 32-32-14.3-32-32-32-32 14.3-32 32zm160-80c0-79.5 64.5-144 144-144s144 64.5 144 144-64.5 144-144 144-144-64.5-144-144zm76.7-11.3c-6.2 6.2-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0z"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/fill-tablet-check.js